import { Typography, TypographyProps } from '@mui/material';
import { formatForDisplay } from 'shared/lib';

interface NumberFormatProps extends TypographyProps {
  children: number | string;
  decimals?: number;
  withComas?: boolean;
  prefix?: string;
  symbol?: string;
}

const NumberFormat = ({
  children,
  decimals = 0,
  withComas = false,
  prefix,
  symbol,
  ...typographyProps
}: NumberFormatProps) => {
  const formattedValue = formatForDisplay(children, decimals, withComas);

  return (
    <Typography
      component="span"
      variant="inherit"
      color="inherit"
      fontFamily="inherit"
      fontWeight="inherit"
      {...typographyProps}
    >
      {prefix}
      {formattedValue}
      {symbol && ` ${symbol}`}
    </Typography>
  );
};

export { NumberFormat };
